export default "__VITE_ASSET__DN7HVDDz__"